var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLeaderboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.7071 6.70711C24.0976 6.31658 24.0976 5.68342 23.7071 5.29289C23.3166 4.90237 22.6834 4.90237 22.2929 5.29289L13.5 14.0858L9.20711 9.79289C8.81658 9.40237 8.18342 9.40237 7.79289 9.79289L0.292893 17.2929C-0.0976311 17.6834 -0.0976311 18.3166 0.292893 18.7071C0.683418 19.0976 1.31658 19.0976 1.70711 18.7071L8.5 11.9142L12.7929 16.2071C13.1834 16.5976 13.8166 16.5976 14.2071 16.2071L23.7071 6.70711Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 6C16 5.44772 16.4477 5 17 5H23C23.5523 5 24 5.44772 24 6V12C24 12.5523 23.5523 13 23 13C22.4477 13 22 12.5523 22 12V7H17C16.4477 7 16 6.55228 16 6Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeaderboard);
export default __webpack_public_path__ + "static/media/leaderboard.82ff482125a3e0d237ac44efdb0cd80b.svg";
export { ForwardRef as ReactComponent };